const TIME_OUT = 2000;

const TOOLTIP_CONFIG = {
  trigger: "click mouseenter",
  hideAfter: TIME_OUT,
  position: "top",
};

const BUTTON_STYLES = {
  primary: "primary",
  secondary: "secondary",
  text: "text",
};

const BUTTON_SIZES = {
  small: "small",
  medium: "medium",
  large: "large",
};

export { TOOLTIP_CONFIG, TIME_OUT, BUTTON_STYLES, BUTTON_SIZES };
